module.exports = __webpack_public_path__ + "img/btn.335b7c3f.png";